import { Col, Form, InputGroup, Row } from 'react-bootstrap';
import {
  getParamFunnelStep,
  getParamTestName,
  getParamVersionNumber,
  updateParamFunnelStep,
  updateParamTestName,
  updateParamVersionNumber
} from '../wto-utils';

interface TrackingUrlParameterSectionProps {
  utmTestId: string;
  readOnly: boolean;
  onChange: (utmTestId: string) => void;
}

export const TrackingUrlParameterSection = ({
  utmTestId,
  readOnly,
  onChange
}: TrackingUrlParameterSectionProps) => (
  <Row className='tracking-url-param-wrapper'>
    <Form.Group as={Col} className='form-group'>
      <Form.Label>Route Tracking URL Parameter</Form.Label>
      <div className='helper-text'>
        <p>
          This field is for reporting and the value for this field should include a key name, route
          name and proute version number. Values should be formatted as:
          <br />
          <br />
          <span className='route-url'>
            {'utm_<insert key name>_exp=<insert route name>< insert route version number>'}
          </span>
          <br />
          <br />
          Former Client Example: utm_home_exp=home4
          <br />
          <br />
          Additional notes on the Route Tracking URL Parameter:
        </p>
        <ul>
          <li>Must be unique (no two Plover tests can have the same RTU parameter)</li>
          <li>
            If a Plover test was duplicated, you will want to update this field to your liking
          </li>
          <li>
            Once a Plover test has been deployed, the chosen variant ID will be appended to the end
            of this parameter. Ex utm_home_exp=home1_
            {'<variant id>'}
          </li>
        </ul>
        <div className='tracking-parameter-builder tracking-fields'>
          utm_
          <Form.Control
            data-testid='tracking-funnel-step'
            value={getParamFunnelStep(utmTestId)}
            disabled={readOnly}
            type='text'
            placeholder='Funnel Step'
            onChange={e => onChange(updateParamFunnelStep(e.target.value, utmTestId))}
          />
          _exp=
          <InputGroup>
            <Form.Control
              className='test-name'
              data-testid='tracking-test-name'
              value={getParamTestName(utmTestId)}
              disabled={readOnly}
              type='text'
              placeholder='Test Name'
              onChange={e => onChange(updateParamTestName(e.target.value, utmTestId))}
            />
            {/* TODO(DEV-24309): no input for a suffix yet -- see wto-utils.ts. */}
            <Form.Control
              className='version'
              data-testid='tracking-version'
              value={getParamVersionNumber(utmTestId)}
              disabled={readOnly}
              type='number'
              placeholder='Version'
              onChange={e => onChange(updateParamVersionNumber(Number(e.target.value), utmTestId))}
            />
          </InputGroup>
        </div>
      </div>
    </Form.Group>
  </Row>
);
